import { Component, OnInit, ViewChild, ElementRef, AfterContentInit, inject, ChangeDetectionStrategy, signal, DestroyRef } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { MetaService } from '../../meta.service';
import { ResizeService, AuthService } from '../../auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatError, MatHint } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { NgTemplateOutlet } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { PaintDirective } from '../../paint.directive';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { backend } from '../../../environments/environment';

interface IEnquiry {
  name?: string;
  email?: string;
  country_code?: string;
  phone?: string;
  enquiry: string;
}

@Component({
  selector: 'contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['../info/info.component.scss', './contact-us.component.scss', '../profile/details/profile-details.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatHint, MatError, MatIconModule, NgTemplateOutlet, MatButtonModule, RouterLink, PaintDirective]
})
export default class ContactUsComponent {
  meta = inject(MetaService);
  size = inject(ResizeService);
  destroy = inject(DestroyRef);
  toast = inject(ToastrService);
  http = inject(HttpClient);

  form: FormGroup = new FormGroup({
    name: new FormControl('', { validators: [Validators.required], nonNullable: true }),
    phone: new FormControl('', { validators: [], nonNullable: true }),
    email: new FormControl('', { validators: [Validators.required, Validators.email], nonNullable: true }),
    enquiry: new FormControl('', { validators: [Validators.required], nonNullable: true })
  })

  isSubmitting = signal<boolean>(false);

  constructor() {
    this.meta.setTags('cloudigo Malta - Contact Us', 'Got a Question? Let us know and we will email you as soon as possible!');

    if (this.meta.displayName()) {
      this.form.get('name')!.setValue(this.meta.displayName());
    }
  }

  submit() {
    if (!this.isSubmitting() && this.form.valid) {
      this.isSubmitting.set(true);
      const enquiry: IEnquiry = this.form.value;

      this.http.post<{ message: string }>(backend + 'contact-us', enquiry).pipe(takeUntilDestroyed(this.destroy)).subscribe({
        next: result => {
          this.form.get('enquiry')!.reset();
          this.isSubmitting.set(false);
          this.toast.info(result.message);
        },
        error: error => {
          error = error.error || error;
          this.toast.error(error.message);
        }
      });
    }
  }

}
